// extracted by mini-css-extract-plugin
export var accordion = "Accordion-module--accordion--008cb";
export var cdsAssistiveText = "Accordion-module--cds--assistive-text--d1afd";
export var cdsVisuallyHidden = "Accordion-module--cds--visually-hidden--bd788";
export var hideFeedback = "Accordion-module--hide-feedback--cabec";
export var showFeedback = "Accordion-module--show-feedback--23d87";
export var skeleton = "Accordion-module--skeleton--31028";